import React from 'react';
import { motion } from 'framer-motion';
import { Check, X, BookOpen, Drama, Landmark } from 'lucide-react';
export function PlanProfesionalBeneficios() {
  const negativos = ['Solo material de enseñanza general', 'Sin vocabulario técnico para clases especializadas', 'Sin simulaciones para trabajar en el aula', 'Sin material institucional para presentar'];
  const positivos = ['Glosario técnico de 290 señas por especialidad para clases avanzadas', '16 simulaciones profesionales para trabajar con tus alumnos', 'Kit institucional con protocolo y cartelería para tu espacio', 'Acceso a futuras actualizaciones del vocabulario técnico'];
  const bonos = [{
    icon: BookOpen,
    label: 'Plan Profesional #1',
    emoji: '📖',
    title: 'Glosario Técnico por Especialidad',
    desc: '290 señas técnicas de Salud, Legal, Educación y Banca. Para cuando tus alumnos necesitan LSA especializado y vos necesitás estar un paso adelante.'
  }, {
    icon: Drama,
    label: 'Plan Profesional #2',
    emoji: '🎭',
    title: 'Guía de Simulaciones para el Aula',
    desc: '16 situaciones profesionales completas con diálogos. Actividades de rol listas para usar con tus alumnos avanzados.'
  }, {
    icon: Landmark,
    label: 'Plan Profesional #3',
    emoji: '🏛️',
    title: 'Kit Institucional para tu Espacio',
    desc: 'Protocolo de atención, cartelería y marco legal. Para presentar tu espacio como un entorno profesional y accesible.'
  }];
  return <section className="bg-lsa-dark text-white py-12 px-5 border-t border-white/10" data-id="element-141">
      <div className="max-w-3xl mx-auto" data-id="element-142">
        <div className="text-center mb-8" data-id="element-143">
          <span className="inline-flex items-center gap-2 bg-lsa-cyan/15 text-lsa-cyan rounded-full px-4 py-1.5 text-xs font-bold uppercase tracking-wide mb-4" data-id="element-144">
            ⭐ Exclusivo del Plan Profesional
          </span>
          <h2 className="text-[26px] sm:text-[32px] font-extrabold leading-tight tracking-tight mb-3" data-id="element-145">
            Tu institución o taller, al{' '}
            <span className="text-lsa-cyan" data-id="element-146">siguiente nivel.</span>
          </h2>
          <p className="text-white/60 text-[15px] max-w-md mx-auto" data-id="element-147">
            Para profesores que coordinan equipos, talleres o instituciones y
            necesitan herramientas avanzadas.
          </p>
        </div>

        {/* COMPARISON CARDS */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-12" data-id="element-148">
          {/* Negative */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-[#0E1730]/50 border border-white/10 rounded-2xl p-6" data-id="element-149">
            <span className="inline-flex items-center gap-2 bg-white/5 text-white/60 rounded-full px-3 py-1 text-[11px] font-bold uppercase tracking-wide mb-4" data-id="element-150">
              <X size={14} data-id="element-151" /> Si no tenés el Plan Profesional
            </span>
            <h3 className="font-bold text-[18px] mb-5 text-white/90" data-id="element-152">
              Solo tenés el sistema base
            </h3>
            <ul className="space-y-3" data-id="element-153">
              {negativos.map((item, i) => <li key={i} className="flex items-start gap-2.5 text-[14px] text-white/60" data-id="element-154">
                  <X className="text-red-400/80 shrink-0 mt-0.5" size={18} data-id="element-155" />
                  <span data-id="element-156">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* Positive */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="relative bg-[#0E1730] border-2 border-lsa-cyan rounded-2xl p-6 shadow-[0_0_24px_rgba(25,199,232,0.18)]" data-id="element-157">
            <span className="absolute -top-3 left-1/2 -translate-x-1/2 inline-flex items-center gap-1.5 bg-lsa-cyan text-lsa-deep rounded-full px-3 py-1 text-[11px] font-bold uppercase tracking-wide whitespace-nowrap" data-id="element-158">
              👑 Recomendado
            </span>
            <span className="inline-flex items-center gap-2 bg-lsa-cyan/15 text-lsa-cyan rounded-full px-3 py-1 text-[11px] font-bold uppercase tracking-wide mb-4" data-id="element-159">
              <Check size={14} data-id="element-160" /> Si tenés el Plan Profesional
            </span>
            <h3 className="font-bold text-[18px] mb-5" data-id="element-161">
              Tenés un sistema profesional completo
            </h3>
            <ul className="space-y-3" data-id="element-162">
              {positivos.map((item, i) => <li key={i} className="flex items-start gap-2.5 text-[14px] text-white/90" data-id="element-163">
                  <Check className="text-lsa-cyan shrink-0 mt-0.5" size={18} data-id="element-164" />
                  <span data-id="element-165">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>

        {/* EXCLUSIVE BONUSES */}
        <div className="text-center mb-8" data-id="element-166">
          <h3 className="text-[22px] sm:text-[26px] font-extrabold leading-tight mb-2" data-id="element-167">
            3 bonos exclusivos del Plan Profesional
          </h3>
          <p className="text-white/60 text-[15px]" data-id="element-168">
            Solo disponibles si elegís el Plan Profesional
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5" data-id="element-169">
          {bonos.map((bono, i) => {
          const Icon = bono.icon;
          return <motion.div key={i} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="bg-[#0E1730]/50 border border-white/10 rounded-2xl p-6" data-id="element-170">
                <div className="flex items-center gap-3 mb-4" data-id="element-171">
                  <div className="w-11 h-11 rounded-xl bg-lsa-cyan/15 flex items-center justify-center text-lsa-cyan shrink-0" data-id="element-172">
                    <Icon size={22} data-id="element-173" />
                  </div>
                  <span className="text-[12px] font-bold uppercase tracking-wide text-lsa-cyan" data-id="element-174">
                    {bono.label}
                  </span>
                </div>
                <h4 className="font-bold text-[17px] mb-3 leading-snug" data-id="element-175">
                  <span className="mr-1" data-id="element-176">{bono.emoji}</span>
                  {bono.title}
                </h4>
                <p className="text-[14px] text-white/65 leading-relaxed" data-id="element-177">
                  {bono.desc}
                </p>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}